import styles from "./element_title.module.css";
import Tooltip from "@mui/material/Tooltip";

export default function ElementTitle(props) {
  const { required = false, title = "" } = props;
  return (
    <div>
      {required ? (
        <Tooltip title="Required Field">
          <span className={styles.required}>*</span>
        </Tooltip>
      ) : null}
      {required ? title : <span className={styles.filler}>{title}</span>}
    </div>
  );
}
